// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignAdmin_container__1YA9N","campaignContainer":"CampaignAdmin_campaignContainer__23_HK","seasonsContainer":"CampaignAdmin_seasonsContainer__9O100"};